import { render, staticRenderFns } from "./RiskPage.vue?vue&type=template&id=60574a41&scoped=true"
import script from "./RiskPage.vue?vue&type=script&lang=js"
export * from "./RiskPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60574a41",
  null
  
)

export default component.exports